import { createReducer } from '@reduxjs/toolkit'
import {
  GET_CATEGORIES,
  GET_CATEGORIES_SUCCESSFUL,
  GET_CATEGORIES_FAILURE
} from './types'

const initialState = {
  items: [],
  isFetching: false,
  isError: false,
  errorMessage: ''
}

const getOccupationsReducer = createReducer(initialState, {
  [GET_CATEGORIES]: (state, action) => ({
    ...state,
    isFetching: true,
    isError: false,
    errorMessage: ''
  }),
  [GET_CATEGORIES_SUCCESSFUL]: (state, action) => ({
    ...state,
    items: action.payload,
    isFetching: false,
    isError: false,
    errorMessage: ''
  }),
  [GET_CATEGORIES_FAILURE]: (state, action) => ({
    ...state,
    isFetching: false,
    items: [],
    isError: true,
    errorMessage: action.payload
  })
})

export default getOccupationsReducer
